module.exports = __webpack_public_path__ + "r-v3/img/sticker_7_icon.0834c4cf.svg";